import React, { useState, useEffect } from "react";
import { Typography, Button, Form, Input } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import Pageloader from "../../../../components/loader";
import { validationErrors } from "../../../../utils/Helpers";
import { useNavigate, useParams } from "react-router-dom";
import * as notificationAction from "../../../../redux/actions/notification.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title } = Typography;
const pageName = "Category";
const pageLink = "categories";

const CategoriesAdd = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { postid } = params;
  const [loading, setLoading] = useState(false);
  const [pageType, setpageType] = useState("Add new");

  useEffect(() => {
    if (postid){
      setpageType("Edit");
      ForSingleDataEdit(postid)
    }
  }, [postid])
  
  const ForSingleDataEdit = async (id) => {
    try {
      setLoading(true);
      await props.notificationAction.singleCategoriesAction(id);
    } catch (e) { } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props?.categoriesView?.length !== 0 && postid){
      form.setFieldsValue(props.categoriesView);
    }
  }, [props.categoriesView, postid])
  const [form] = Form.useForm();
  
  const onFinish = async (values) => {
    let dataFix ={
      ...values,
    }
    try {
      setLoading(true);
      if (pageType === "Edit"){
        await props.notificationAction.patchCategoriesAction(dataFix, postid);
      } else {
        await props.notificationAction.postCategoriesAction(dataFix);
      }
      navigate(`/${pageLink}`)
    } catch (e) { 
      validationErrors(e)
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{`${pageType} ${pageName}`}</Title>
        <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
      </div>
      <div className="p-content">
        {loading ? <Pageloader />:
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
              name={["title"]}
              label={"Title"}
              rules={[{required: true, message: "Please enter value"}]}
            >
              <Input />
          </Form.Item>
          <Form.Item
              name={["color"]}
              label={"Color"}
            >
              <Input type="color" />
          </Form.Item>
          <Button className="submit mt-15" htmlType="submit">{postid ? "Update" : "Submit"}</Button>
        </Form>
        }
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    categoriesView: state.NotificationReducer.categoriesView,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    notificationAction: bindActionCreators(notificationAction, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesAdd);